
import { ROWS, COLUMNS, getCoords, createGrid } from './utils';
import { COLORS } from './colors';

export function createRenderer() {

  const dots = [];
  const clickHandlers = [];
  const dotsContainer = document.querySelector('.dots');
  const clickHandlerContainer = document.querySelector('.click-handlers');

  for (let index = 0; index < ROWS * COLUMNS; index++) {
    const dot = document.createElement('div');
    dot.className = 'dot';
    dot.style.opacity = 0;
    dotsContainer.appendChild(dot);
    dots.push(dot);

    const clickHandler = document.createElement('div');
    clickHandler.className = 'click-handler';
    clickHandlerContainer.appendChild(clickHandler);
    clickHandlers.push(clickHandler);
  }

  function render(data, delta) {

    // handle sustained presses
    if (pointerDown && activeCell !== null) {
      const coords = getCoords(activeCell);
      interactionListeners
        .filter(handler => handler.opts.repeat)
        .forEach(handler => handler.handler(coords));
    } else {
      activeCell = null;
    }

    if (data.length !== dots.length) {
      throw(`data is wrong length`)
    }
    data.forEach((d, i) => {
      if (d && typeof d === 'string' && !COLORS[d]) {
        console.warn(`invalid color: ${d}`);
      }
      let color = null;
      if (d && typeof d === 'string' && COLORS[d]) {
        color = COLORS[d];
      } else if (d) {
        color = COLORS.ui1;
      } else {
        color = COLORS.ui4
      }
      dots[i].style.background = color;
    });  
  }

  let interactionListeners = [];
  let activeCell = null;

  let pointerDown = false;
  document.body.addEventListener('pointerdown', event => {
    pointerDown = true;
    handleOutsideBounds(event);
  });
  document.body.addEventListener('pointermove', event => {
    handleOutsideBounds(event);
  });  
  clickHandlerContainer.addEventListener('pointerleave', () => {
    activeCell = null;
  });
  document.body.addEventListener('pointerup', () => {
    pointerDown = false;
  });
  clickHandlers.forEach((el, i) => {
    const coords = getCoords(i);
    el.addEventListener('pointermove', (event) => {
      event.stopPropagation();
      interactionListeners.forEach(handler => {
        if (!handler.opts.repeat && (pointerDown || handler.opts.onHover)) {
          handler.handler(coords);
        }
        activeCell = i;
      });
    });
    el.addEventListener('pointerdown', (event) => {
      interactionListeners.forEach(handler => handler.handler(coords));
    });
  });
  function handleOutsideBounds(event) {
    const middle = window.innerWidth * 0.5;
    const bounds = {
      left: middle - 320/2,
      right: middle + 320/2,
      width: 320
    }
    const colWidth = 320/15;
    const column = Math.round((event.pageX - bounds.left) / colWidth);
    interactionListeners
      .filter(h => h.opts.outsideBounds)
      .forEach(handler => {
        let x = 0;
        if (event.pageX > bounds.right) {
          x = COLUMNS - 1;
        }
        if (event.pageX < bounds.right && event.pageX > bounds.left) {
          x = column;
        }
        handler.handler({x, y: 0 });
      });

  }

  function addInteractionListener(handler, opts = {}) {
    interactionListeners.push({handler, opts});
  }
  function removeAllInteractionListeners() {
    interactionListeners = [];
  }
  function removeInteractionListener(handler) {
    interactionListeners = interactionListeners.filter(h => h.handler !== handler);
  }
  function showDots() {
    dots.forEach((d, i) => {
      setTimeout(() => {
        d.style.opacity = 1;
      }, i * 5);
    });
  }

  return {
    render,
    addInteractionListener,
    removeInteractionListener,
    removeAllInteractionListeners,
    showDots
  };
}
